import MarketPlacePage from './MarketPlacePage';

export default MarketPlacePage;